<template>
  <v-container
    id="towerKpis"
    fluid
    tag="section"
  >
    <v-card
      class="mx-4 px-4 py-4"
    >
      <v-container>
        <v-row>
          <v-col>
            <v-btn
              @click="doGetCalculations"
            >
              Refresh
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
<!--          Totals-->
          <base-sq-card
            title="Totals"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Key
                  </th>
                  <th class="text-left">
                    Value
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(value, key) in kpis.totals"
                  :key="key + '-totals'"
                >
                  <td><span class="key-label">{{ key }}</span></td>
                  <td
                    style="vertical-align: middle"
                  >
                    <v-text-field
                      readonly
                      outlined
                      :value="value"
                      style="width: 60%"
                      class="mt-2"
                    >
                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>

          </base-sq-card>
          <!--          Statement Methods-->
          <base-sq-card
            title="Statement Methods"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Key
                  </th>
                  <th class="text-left">
                    Value
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(value, key) in kpis.statementMethods"
                  :key="key + '-totals'"
                >
                  <td><span class="key-label">{{ key }}</span></td>
                  <td
                    style="vertical-align: middle"
                  >
                    <v-text-field
                      readonly
                      outlined
                      :value="value.count"
                      style="width: 60%"
                      class="mt-2"
                    >
                      <template v-slot:append>
                        ({{ value.percent }}%)
                      </template>
                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </base-sq-card>
          <!--          Customer Status-->
          <base-sq-card
            title="Customer Status"
          >
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Key
                  </th>
                  <th class="text-left">
                    Value
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(value, key) in kpis.customerStatus"
                  :key="key + '-totals'"
                >
                  <td><span class="key-label">{{ key }}</span></td>
                  <td
                    style="vertical-align: middle"
                  >
                    <v-text-field
                      readonly
                      outlined
                      :value="value"
                      style="width: 60%"
                      class="mt-2"
                    >
                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </base-sq-card>
<!--          Rates-->
          <base-sq-card
            title="Rates"
          >
            <v-simple-table
              dense
            >
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">
                    Key
                  </th>
                  <th class="text-left">
                    Value
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(value, key) in kpis.rates"
                  :key="key + '-totals'"
                >
                  <td><span class="key-label">{{ value.name }}</span></td>
                  <td
                    style="vertical-align: middle"
                  >
                    <v-text-field
                      readonly
                      outlined
                      :value="value.count"
                      style="width: 60%"
                      class="mt-2"
                    >
                      <template v-slot:append>
                        ({{ value.percent }}%)
                      </template>
                    </v-text-field>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </base-sq-card>

          <!--          Towers-->
          <base-sq-card
            v-for="(tower, towerNum) in kpis.towers"
            :key="towerNum + '-tower'"
          >
            <template v-slot:heading>
              <span class="tile-card-heading">{{ towerNum }}</span>
              <v-spacer></v-spacer>
            </template>
            <v-row>
              <base-sq-card
                title="Totals"
                color="teal"
              >
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left">
                        Key
                      </th>
                      <th class="text-left">
                        Value
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="(value, key) in tower.totals"
                      :key="key + '-totals'"
                    >
                      <td><span class="key-label">{{ key }}</span></td>
                      <td
                        style="vertical-align: middle"
                      >
                        <v-text-field
                          readonly
                          outlined
                          :value="value"
                          style="width: 60%"
                          class="mt-2"
                        >
                        </v-text-field>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </base-sq-card>
              <base-sq-card
                title="Statement Methods"
                color="pink"
              >
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left">
                        Key
                      </th>
                      <th class="text-left">
                        Value
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="(value, key) in tower.statementMethods"
                      :key="key + '-totals'"
                    >
                      <td><span class="key-label">{{ key }}</span></td>
                      <td
                        style="vertical-align: middle"
                      >
                        <v-text-field
                          readonly
                          outlined
                          :value="value.count"
                          style="width: 60%"
                          class="mt-2"
                        >
                          <template v-slot:append>
                            ({{ value.percent }}%)
                          </template>
                        </v-text-field>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </base-sq-card>
              <base-sq-card
                title="Rates"
                color="pink"
              >
                <v-simple-table
                  dense
                >
                  <template v-slot:default>
                    <thead>
                    <tr>
                      <th class="text-left">
                        Key
                      </th>
                      <th class="text-left">
                        Value
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      v-for="(value, key) in tower.rates"
                      :key="key + '-totals'"
                    >
                      <td><span class="key-label">{{ value.name }}</span></td>
                      <td
                        style="vertical-align: middle"
                      >
                        <v-text-field
                          readonly
                          outlined
                          :value="value.count"
                          style="width: 60%"
                          class="mt-2"
                        >
                          <template v-slot:append>
                            ({{ value.percent }}%)
                          </template>
                        </v-text-field>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </base-sq-card>
            </v-row>
          </base-sq-card>
        </v-row>
      </v-container>
      <v-overlay
        :value="isLoading"
        :absolute="true"
      >
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

    </v-card>
  </v-container>
</template>

<script>
  // import { mapActions, mapGetters } from 'vuex'
  import ReportingService from '@/services/reporting.service'

  export default {
    name: 'TowerKPIs',

    data () {
      return {
        isLoading: false,
        kpis: {},
        headersTowers: [
          {
            text: 'Tower',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'Name',
          },
          {
            text: 'Number',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'Number',
          },
          {
            text: 'Location',
            align: 'start',
            sortable: true,
            groupable: true,
            value: 'Lat',
          },
          {
            text: 'Subscribers',
            align: 'start',
            sortable: true,
            groupable: false,
            value: 'count',
          },
        ],
      }
    },
    computed: {
      // ...mapGetters(['reportingWirelessServices', 'reportingTowers']),
    },
    async created () {
      console.log('page loaded')
      console.log(this.$route)
      await this.doGetCalculations()
    },
    mounted () {

      // const queryParams = this.$route.params
    },
    methods: {
      async doGetCalculations () {
        this.isLoading = true
        try {
          const { data } = await ReportingService.getCalculatedTowers()
          this.kpis = data
          console.log(data)
        } catch (e) {
          this.isLoading = false
          console.log(e)
        }
        this.isLoading = false
      },
    },
  }
</script>
